<template>
  <div>
    <CCard class="mb-4 border-0">
      <CCardBody class="p-4">
        <router-link to="/employee/claimList" class="small d-inline-block mb-2">&larr; My claims</router-link>
        <CRow class="align-items-center">
          <CCol md="6">
            <h1 class="h4 mb-1 font-weight-bold">
              {{ obj.id ? `Claim ${obj.claimNo || ""}` : "New claim" }}
              <CBadge
                v-if="obj.claimStateDescription"
                :color="hrStatusColor('claim', obj.claimStateDescription)"
                class="ml-2 align-middle"
              >
                {{ hrStatusLabel('claim', obj.claimStateDescription) }}
              </CBadge>
            </h1>
            <p class="text-muted mb-0">{{ headerSubtitle }}</p>
          </CCol>
          <CCol md="6" class="d-flex flex-wrap justify-content-md-end align-items-center mt-3 mt-md-0">
            <CDropdown
              v-if="obj.id"
              placement="bottom-end"
              toggler-text="More"
              color="light"
              class="mr-2 mb-2 mb-md-0"
            >
              <CDropdownItem @click="addNew()">Add claim</CDropdownItem>
              <template v-if="computedClaimStates.length">
                <CDropdownDivider />
                <CDropdownItem
                  v-for="status in computedClaimStates"
                  :key="status.id"
                  @click="askChangeState(status)"
                >
                  {{ stateActionLabel(status.name) }}
                </CDropdownItem>
              </template>
            </CDropdown>
            <CButton color="light" class="mr-2 mb-2 mb-md-0" :disabled="saving" @click="cancel">Cancel</CButton>
            <CButton v-if="isEditable" color="primary" class="mb-2 mb-md-0" :disabled="saving" @click="submit">
              <CSpinner v-if="saving" size="sm" class="mr-1" />
              {{ obj.id ? "Save" : "Create claim" }}
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol>
                <CInput
                  horizontal
                  label="Date *"
                  type="date"
                  :value="computeDate"
                  @change="setDate"
                  :readonly="!isEditable"
                />
                <!-- <CInput label="Claim No" horizontal v-model="obj.claimNo" /> -->
              </CCol>
              <CCol>
                <!-- <CInput
                  horizontal
                  label="Date"
                  type="date"
                  :value="computeDate"
                  @change="setDate"
                /> -->
              </CCol>
              <CCol>
                <!-- <CSelect
                  horizontal
                  :value.sync="selectedClaimState"
                  :options="claimStates"
                  label="Claim State"
                /> -->
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <h2 class="h6 mt-2 mb-3">Items</h2>
                <CDataTable :items="computedClaimItems" :fields="claimFields" responsive>
                  <template #show_index="{ index }">
                    <td class="py-2">
                      {{ index + 1 }}
                    </td>
                  </template>
                  <template #show_date="{ item }">
                    <td>
                      <CInput type="date" v-model="item.date" aria-label="Item date" class="mb-0" />
                    </td>
                  </template>

                  <template #show_item="{ item }">
                    <td>
                      <CInput v-model="item.name" aria-label="Item" placeholder="What you bought" class="mb-0"></CInput>
                    </td>
                  </template>
                  <template #show_description="{ item }">
                    <td>
                      <CTextarea
                        v-model="item.description"
                        rows="1"
                        aria-label="Description"
                        class="mb-0"
                      />
                    </td>
                  </template>
                  <template #show_quantity="{ item }">
                    <td>
                      <CInput v-model="item.quantity" type="number" min="1" inputmode="numeric" aria-label="Quantity" class="mb-0"></CInput>
                    </td>
                  </template>
                  <template #show_unit="{ item }">
                    <td>
                      <CInput v-model="item.unit" aria-label="Unit" class="mb-0"></CInput>
                    </td>
                  </template>
                  <template #show_receipt="{ item }">
                    <td class="py-2">
                      <div v-if="item.receipt && item.receipt.documentId">
                        <div v-if="item.receipt.document">
                          <div v-if="helper.isPdf(item.receipt.document)">
                            <iframe
                              :src="helper.getDocumentUrl(item.receipt.document)"
                              class="receipt-frame border rounded"
                              title="Receipt"
                            ></iframe>
                          </div>
                          <div v-else>
                            <CImg
                              :src="helper.getDocumentUrl(item.receipt.document)"
                              class="receipt-img border rounded"
                              alt="Receipt"
                            />
                          </div>
                        </div>
                        <a
                          :href="helper.getDocumentUrl(item.receipt.document)"
                          target="_blank"
                          class="d-block my-1"
                          >View receipt</a
                        >
                        <template v-if="isEditable">
                          <CButton size="sm" color="light" class="mr-1" @click="openReceiptPicker(item)">Change</CButton>
                          <CButton size="sm" color="light" @click="removeReceipt(item)">Remove</CButton>
                        </template>

                      </div>
                      <div v-else>
                        <CButton
                          v-if="isEditable"
                          size="sm"
                          color="light"
                          @click="openReceiptPicker(item)"
                          ><CIcon name="cil-paperclip" /> Attach receipt</CButton
                        >
                        <span v-else class="text-muted">None</span>
                      </div>
                    </td>
                  </template>
                  <template #show_price="{ item }">
                    <td>
                      <CInput
                        v-model="item.amount"
                        type="number"
                        min="0"
                        step="0.01"
                        inputmode="decimal"
                        prepend="RM"
                        aria-label="Price"
                        class="mb-0"
                      ></CInput>
                    </td>
                  </template>
                  <template #show_total="{ item }">
                    <td class="text-right text-nowrap">
                      {{ money(getTotalItemPrice(item)) }}
                    </td>
                  </template>
                  <template #show_move="{ item, index }">
                    <td class="py-2">
                      <div v-if="isEditable" class="btn-group-vertical">
                        <CButton
                          color="light"
                          size="sm"
                          aria-label="Move up"
                          title="Move up"
                          @click="moveItem(index, 'up')"
                          :disabled="index === 0"
                        >
                          <CIcon name="cil-chevron-top" />
                        </CButton>
                        <CButton
                          color="light"
                          size="sm"
                          aria-label="Move down"
                          title="Move down"
                          @click="moveItem(index, 'down')"
                          :disabled="index === computedClaimItems.length - 1"
                        >
                          <CIcon name="cil-chevron-bottom" />
                        </CButton>
                      </div>
                    </td>
                  </template>
                  <template #show_remove="{ item }">
                    <td class="py-2">
                      <CButton
                        v-if="isEditable"
                        color="light"
                        :aria-label="`Remove ${item.name || 'item'}`"
                        title="Remove"
                        @click="onRemoveClaimItem(item)"
                      >
                        <CIcon name="cil-trash" />
                      </CButton>
                    </td>
                  </template>

                  <template #footer>
                    <td colspan="2">
                      <CButton v-if="isEditable" @click="addNewItem()" color="light"
                        ><CIcon name="cil-plus" /> Add item</CButton
                      >
                    </td>
                    <td colspan="5" class="text-right">
                      <strong>Total</strong>
                    </td>
                    <td class="text-right text-nowrap"><strong>{{ money(grandTotal) }}</strong></td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter v-if="isEditable" class="d-flex justify-content-end">
            <CButton color="light" class="mr-2" :disabled="saving" @click="cancel">Cancel</CButton>
            <CButton color="primary" :disabled="saving" @click="submit">
              <CSpinner v-if="saving" size="sm" class="mr-1" />
              {{ obj.id ? "Save" : "Create claim" }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal :show.sync="showReceiptModal" title="Attach a receipt" size="xl">
      <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">Choose one of your uploaded receipts.</span>
          <CButton color="light" @click="createNewReceipt"
            ><CIcon name="cil-plus" /> Upload receipt</CButton
          >
        </div>
        <CRow class="mb-3">
          <CCol md="4">
            <CInput
              label="Shop or company"
              placeholder="For example, Tesco"
              v-model="filterCompany"
            />
          </CCol>
          <CCol md="4">
            <CInput
              label="Minimum amount"
              placeholder="0.00"
              v-model.number="filterAmount"
              type="number"
              prepend="RM"
              inputmode="decimal"
            />
          </CCol>
          <CCol md="4">
            <CInput label="Date" type="date" v-model="filterDate" />
          </CCol>
        </CRow>
        <!-- <CRow>
          <CCol>
            <CSelect
  label="Sort By"
  :options="['Date Desc', 'Date Asc', 'Amount High', 'Amount Low']"
  v-model="sortOption"
/>
          </CCol>
        </CRow> -->

        <div v-if="loadingReceipts" class="text-center py-4"><CSpinner color="primary" /></div>
        <div v-else-if="!availableReceipts.length" class="text-center py-4">
          <p class="mb-2">You haven't uploaded any receipts yet.</p>
          <CButton color="primary" @click="createNewReceipt"><CIcon name="cil-plus" /> Upload receipt</CButton>
        </div>
        <div v-else-if="!filteredReceipts.length" class="text-center py-4">
          <p class="mb-2">No receipts match your filters.</p>
          <CButton color="light" @click="clearReceiptFilters"><CIcon name="cil-x" /> Clear filters</CButton>
        </div>
        <CRow v-else class="mt-3">
          <CCol
            v-for="receipt in filteredReceipts"
            :key="receipt.id"
            sm="6"
            md="4"
            lg="3"
            class="mb-4"
          >
            <CCard
              @click="selectReceipt(receipt)"
              @keydown.enter.prevent="selectReceipt(receipt)"
              @keydown.space.prevent="selectReceipt(receipt)"
              tabindex="0"
              role="button"
              :aria-label="`Attach receipt from ${receipt.companyName || 'unknown'}, ${money(receipt.totalAmount)}`"
              class="receipt-option h-100"
            >
              <CCardBody>
                <div class="mb-2">
                  <div class="font-weight-bold">{{ receipt.companyName }}</div>
                  <small class="text-muted d-block">{{ formatDate(receipt.date) }}</small>
                  <div>{{ money(receipt.totalAmount) }}</div>
                </div>

                <div v-if="receipt.document">
                  <div v-if="helper.isPdf(receipt.document)">
                    <iframe
                      :src="helper.getDocumentUrl(receipt.document)"
                      class="receipt-frame border rounded"
                      title="Receipt"
                      tabindex="-1"
                    ></iframe>
                  </div>
                  <div v-else>
                    <CImg
                      :src="helper.getDocumentUrl(receipt.document)"
                      class="receipt-img border rounded"
                      alt="Receipt"
                    />
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <CButton color="light" @click="showReceiptModal = false">Cancel</CButton>
      </template>
    </CModal>

    <!-- Status change confirmation -->
    <CModal :title="statusConfirmTitle" :show.sync="statusConfirmModal" :close-on-backdrop="!changingState">
      <p class="mb-0">{{ statusConfirmMessage }}</p>
      <template #footer>
        <CButton color="light" :disabled="changingState" @click="statusConfirmModal = false">
          {{ isPendingCancel ? "Keep it" : "Cancel" }}
        </CButton>
        <CButton :color="isPendingCancel ? 'danger' : 'primary'" :disabled="changingState" @click="confirmChangeState">
          <CSpinner v-if="changingState" size="sm" class="mr-1" />
          {{ pendingStatus ? stateActionLabel(pendingStatus.name) : "" }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import ClaimApi from "@/lib/claimApi";
import ReceiptApi from "@/lib/receiptApi";
import { formatDate, asDateString, mytToday } from "@/utils/datetime";
import { formatMyr } from "@/utils/money";
import { hrStatusMixin, hrStatusLabel } from "@/utils/hrStatusBadges";

export default {
  name: "Claim",
  mixins: [hrStatusMixin],
  data: () => {
    return {
      filterCompany: "",
      filterAmount: null,
      filterDate: "",
      receiptApi: new ReceiptApi(),
      showReceiptModal: false,
      availableReceipts: [],
      currentItemForReceipt: null,
      claimItems: [],
      claimFields: [
        {
          key: "show_index",
          label: "#",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },
        // { key: "position", label: "Position" },
        // { key: "date", label: "date" },
        {
          key: "show_date",
          label: "Date",
        },
        {
          key: "show_item",
          label: "Item",
        },
        {
          key: "show_description",
          label: "Description",
        },
        {
          key: "show_quantity",
          label: "Quantity",
          _style: "width:100px",
        },
        {
          key: "show_unit",
          label: "Unit",
          _style: "width:100px",
        },

        {
          key: "show_price",
          label: "Price",
          _style: "width:160px",
        },
        {
          key: "show_total",
          label: "Total",
          _style: "text-align:right",
        },
        {
          key: "show_receipt",
          label: "Receipt",
          _style: "width:160px",
        },
        {
          key: "show_move",
          label: "",
          _style: "width:1%",
        },
        {
          key: "show_remove",
          label: "",
          _style: "width:1%",
        },
      ],
      helper,
      date: Date(),

      // Quotation Itm
      // claimItems: claimItems.map((item, id) => {
      //   return { ...item, id };
      // }),

      // claimFields,

      claimStates: [],
      selectedClaimState: null,
      organizationTypeList: [],
      saving: false,
      loadingReceipts: false,
      statusConfirmModal: false,
      changingState: false,
      pendingStatus: null,
      obj: {
        profile: {
          fullName: "",
        },
        business: {
          name: "",
        },
      },
      submitted: false,
      api: new ClaimApi(),
    };
  },
  mounted() {
    var self = this;
    this.fetchClaimStates();
    this.initializeDefaultDate();
    self.resetObj();
  },
  computed: {
    filteredReceipts() {
      return this.availableReceipts
        .filter((r) => {
          const matchesCompany =
            this.filterCompany === "" ||
            r.companyName
              ?.toLowerCase()
              .includes(this.filterCompany.toLowerCase());
          const matchesAmount =
            !this.filterAmount || r.totalAmount >= this.filterAmount;
          const matchesDate =
            !this.filterDate ||
            asDateString(r.date) === this.filterDate;
          return matchesCompany && matchesAmount && matchesDate;
        })
        .sort((a, b) => {
          return asDateString(b.date).localeCompare(asDateString(a.date)); // Newest first
        });
    },
    computedClaimStates() {
      let statuses = this.claimStates.filter(
        (status) => status.name != this.obj.claimStateDescription
      );

      if (this.obj.id == null) return [];

      if (this.obj.claimStateDescription === "Draft")
        return statuses.filter((status) => status.name == "Submit");
      if (this.obj.claimStateDescription === "Approve")
        return statuses.filter(
          (status) => status.name == "Paid" || status.name == "Cancelled"
        );
      else return [];
    },

    computeDate() {
      return asDateString(this.date);
    },
    isEditable() {
      return !this.obj.claimStateDescription || this.obj.claimStateDescription === "Draft";
    },
    headerSubtitle() {
      if (this.isEditable) return "Add each item you paid for and attach its receipt";
      return `${formatDate(this.date)} · ${this.money(this.grandTotal)}`;
    },
    isPendingCancel() {
      return !!this.pendingStatus && this.pendingStatus.name === "Cancelled";
    },
    statusConfirmTitle() {
      if (!this.pendingStatus) return "";
      const no = this.obj.claimNo ? ` ${this.obj.claimNo}` : "";
      switch (this.pendingStatus.name) {
        case "Submit": return `Submit claim${no}?`;
        case "Paid": return `Mark claim${no} as paid?`;
        case "Cancelled": return `Cancel claim${no}?`;
        default: return `Mark claim${no} as ${hrStatusLabel("claim", this.pendingStatus.name).toLowerCase()}?`;
      }
    },
    statusConfirmMessage() {
      if (!this.pendingStatus) return "";
      const total = this.money(this.grandTotal);
      switch (this.pendingStatus.name) {
        case "Submit": return `Your claim for ${total} will be sent to your employer for approval. You can't edit it after this.`;
        case "Paid": return `The claim for ${total} will be recorded as paid to you.`;
        case "Cancelled": return `The claim for ${total} will be cancelled and won't be paid.`;
        default: return `The claim for ${total} will be marked as ${hrStatusLabel("claim", this.pendingStatus.name).toLowerCase()}.`;
      }
    },
    computedClaimItems() {
      return this.claimItems.map((item) => {
        return {
          ...item,
          date: asDateString(item.date),
          // productName: item.product.name,
          // totalAmountPerItem: this.getTotalItemPrice(item),
        };
      });
    },
    grandTotal() {
      var total = 0;
      for (var i = 0; i < this.computedClaimItems.length; i++) {
        var item = this.computedClaimItems[i];
        total += item.amount * item.quantity;
      }
      return total;
    },
  },
  methods: {
    formatDate,
    money(v) {
      return `RM ${formatMyr(v)}`;
    },
    cancel() {
      this.$router.push({ path: "/employee/claimList" });
    },
    addNew() {
      this.$router.push({ path: "/employee/claim" });
    },
    stateActionLabel(name) {
      if (name === "Submit") return "Submit claim";
      if (name === "Paid") return "Mark as paid";
      if (name === "Cancelled") return "Cancel claim";
      return hrStatusLabel("claim", name);
    },
    clearReceiptFilters() {
      this.filterCompany = "";
      this.filterAmount = null;
      this.filterDate = "";
    },
    askChangeState(status) {
      this.pendingStatus = status;
      this.statusConfirmModal = true;
    },
    confirmChangeState() {
      if (this.pendingStatus) this.changeState(this.pendingStatus);
    },
    removeReceipt(item) {
      item.receipt = null;
      item.receiptId = null;
    },
    openReceiptPicker(item) {
      this.currentItemForReceipt = item;
      this.filterCompany = "";
      this.filterAmount = null;
      this.filterDate = "";

      this.fetchAvailableReceipts();
      this.showReceiptModal = true;
    },
    fetchAvailableReceipts() {
      this.loadingReceipts = true;
      this.receiptApi
        .getListByCurrentUser()
        .then((response) => {
          this.availableReceipts = response.result || [];
        })
        .catch(() => {
          this.toast("Error", "Couldn't load your receipts. Try again.", "danger");
        })
        .finally(() => {
          this.loadingReceipts = false;
        });
    },
    selectReceipt(receipt) {
      this.currentItemForReceipt.receipt = receipt;
      this.currentItemForReceipt.receiptId = receipt.id;
      this.showReceiptModal = false;
    },
    createNewReceipt() {
      this.$router.push("/employee/receipt");
    },
    changeState(item) {
      this.obj.claimState = item.id;
      if (this.obj.id) {
        this.changingState = true;
        this.api
          .updateState(this.obj, null)
          .then((response) => {
            this.toast("Success", item.name === "Submit" ? "Claim submitted" : `Claim marked as ${hrStatusLabel("claim", item.name).toLowerCase()}`, "success");
            this.statusConfirmModal = false;
            this.pendingStatus = null;
            this.resetObj();
          })
          .catch(({ data }) => {
            this.toast("Error", `Couldn't change the claim status. ${helper.getErrorMessage(data)}`, "danger");
          })
          .finally(() => {
            this.changingState = false;
          });
      }
    },
    moveItem(index, direction) {
      const newIndex = direction === "up" ? index - 1 : index + 1;
      if (newIndex >= 0 && newIndex < this.computedClaimItems.length) {
        const temp = this.computedClaimItems[index];
        this.$set(
          this.computedClaimItems,
          index,
          this.computedClaimItems[newIndex]
        );
        this.$set(this.computedClaimItems, newIndex, temp);

        // Update positions after swapping
        this.computedClaimItems[index].position = index + 1;
        this.computedClaimItems[newIndex].position = newIndex + 1;
      }
    },

    onRemoveClaimItem(item) {
      var self = this;
      if (self.computedClaimItems != null) {
        for (var i = 0; i < self.computedClaimItems.length; i++) {
          if (self.computedClaimItems[i].id === item.id) {
            self.computedClaimItems.splice(i, 1);
          }
        }
      }

      this.updatePositions(); // Update positions after removal
    },

    updatePositions() {
      this.computedClaimItems.forEach((item, index) => {
        item.position = index + 1;
      });
    },

    initializeDefaultDate() {
      const today = new Date();
      this.date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      );
    },

    setDate(e) {
      this.date = e; // ISO format assumes local time
    },
    // onRemoveClaimItem(item) {
    //   var self = this;
    //   if (self.computedClaimItems != null) {
    //     for (var i = 0; i < self.computedClaimItems.length; i++) {
    //       if (self.computedClaimItems[i].id === item.id) {
    //         self.computedClaimItems.splice(i, 1);
    //       }
    //     }
    //   }
    // },
    generateGUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    addNewItem() {
      const newPosition = this.claimItems.length + 1;
      this.claimItems.push({
        id: this.generateGUID(),
        date: mytToday(),
        name: "",
        amount: 0,
        unit: "L.S.",
        quantity: 1,
        description: "",
        position: newPosition,
      });
    },
    getTotalItemPrice(item) {
      try {
        return item.quantity * item.amount;
      } catch (error) {
        return 0;
      }
    },

    fetchClaimStates() {
      var self = this;
      self.api
        .getClaimState()
        .then((response) => {
          // var obj = response.result;
          this.claimStates = response.result;
          // this.claimStates = obj.map((state) => ({
          //   value: state.id,
          //   label: state.name,
          // }));
          self.selectedClaimState = 0;
        })
        .catch(({ data }) => {
          self.toast("Error", `Couldn't load everything on this page. Refresh to try again. ${helper.getErrorMessage(data)}`, "danger");
        });
    },
    resetObj() {
      var self = this;
      if (self.$route.params.id) {
        self.api
          .get(self.$route.params.id)
          .then((response) => {
            self.obj = response.result;
            if (self.obj.date) self.date = self.obj.date;

            // Set selectedClaimState to match the current state of the claim
            self.selectedClaimState = self.obj.claimState;

            if (self.obj.items.length > 0) {
              if (self.obj.items[0].position == 0) {
                for (var i = 0; i < self.obj.items.length; i++) {
                  self.obj.items[i].position = i + 1;
                }
              }
            }
            self.claimItems = self.obj.items;
          })
          .catch(({ data }) => {
            self.toast("Error", `Couldn't create the claim. ${helper.getErrorMessage(data)}`, "danger");
          })
          .finally(() => {
            self.saving = false;
          });
      } else {
        self.obj = self.getEmptyObj();
        this.api
          .getNextReferenceNumber()
          .then((response) => {
            self.obj.claimNo = response.result;
          })
          .catch(({ data }) => {});
      }
    },
    onSubmit() {
      var self = this;
      self.obj.date = self.date;
      self.obj.claimState = self.selectedClaimState;
      for (let i = 0; i < self.computedClaimItems.length; i++)
        self.computedClaimItems[i].date = new Date(
          self.computedClaimItems[i].date + "T00:00:00"
        );
      self.obj.items = self.computedClaimItems;
      if (self.saving) return;
      self.saving = true;

      if (!self.obj.id) {
        this.api
          .create(self.obj)
          .then((response) => {
            self.toast("Success", "Claim created", "success");
            var newObj = response.result;
            self.$router.push({
              path: `/employee/Claim/${newObj.id}`,
            });

            this.resetObj();
            // self.$router.push({ path: "/employee/claimList" });
          })
          .catch(({ data }) => {
            self.toast("Error", `Couldn't load everything on this page. Refresh to try again. ${helper.getErrorMessage(data)}`, "danger");
          });
      } else {
        this.api
          .update(self.obj)
          .then((response) => {
            // self.$router.push({ path: "/employee/claimList" });
            self.toast("Success", "Claim saved", "success");
            this.resetObj();
          })
          .catch(({ data }) => {
            self.toast("Error", `Couldn't save the claim. ${helper.getErrorMessage(data)}`, "danger");
          })
          .finally(() => {
            self.saving = false;
          });
      }
    },
    onReset() {
      this.obj = {};
    },
    toast(header, message, color) {
      const kind = { danger: "error", success: "success", warning: "warning" }[color] || "info";
      this.$toast[kind](message);
    },

    checkIfValid(fieldName) {
      const field = this.$v.obj[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validate() {
      this.$v.$touch();
    },
    reset() {
      this.resetObj();
      this.submitted = false;
      this.$v.$reset();
    },
    getEmptyObj() {
      return {
        claimNo: "",
        claimState: 0,
        claimStateDescription: "Draft",
        // name: "",
        // decsription: "",
      };
    },
    submit() {
      this.onSubmit();
      this.submitted = true;
    },
  },
};
</script>

<style scoped>
.receipt-frame {
  width: 100%;
  height: 150px;
}
.receipt-img {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
}
.receipt-option {
  cursor: pointer;
}
</style>
